import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { push } from 'react-router-redux';
import { CheckboxButton, TextInput } from 'sure-components';
import Button from 'shared/lib/components/Button';
import { saveClaimsDeviceSerialNumber } from '../../store/actions';
import * as analytics from 'shared/lib/analytics';
import './ClaimsAuthorizationEmail.css';


class ClaimsAuthorizationEmail extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isNextButtonEnabled: false,
    };
  }

  componentDidMount() {
    document.title = `Claims | Authorization Email - Sure`;
    analytics.page('Portal - Claim Forward Authorization Email', {
      category: 'claim',
    });
  }

  setNextButtonState() {
    analytics.track('Portal - Claim Confirm Forwarded Authorization Email', {
      category: 'claim',
      value: this.confirmationCheckbox.checked ? 1 : 0,
    });
    this.setState({
      isNextButtonEnabled: this.inputSerialNumber.value && this.confirmationCheckbox.checked,
    });
  }

  handleNext() {
    analytics.track('Portal - Claim Forward Authorization Email Next Clicked', {
      category: 'claim',
    });
    const { verticalCode, policyNumber } = this.props.params;
    this.props.saveClaimsDeviceSerialNumber(this.inputSerialNumber.value);
    this.props.navTo(`/account/claims/new/${verticalCode}/policies/${policyNumber}/banking`);
  }

  selectEmailText() {
    var doc = document
      , text = this.claimsEmail
      , range, selection
    ;
    if (doc.body.createTextRange) {
      range = document.body.createTextRange();
      range.moveToElementText(text);
      range.select();
    } else if (window.getSelection) {
      selection = window.getSelection();
      range = document.createRange();
      range.selectNodeContents(text);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }

  render() {
    return (
      <div className="ClaimsAuthorizationEmail">
        <div className="Container Container--small">
          <h1 className="ClaimsAuthorizationEmail-heading">
            Please forward us the repair authorization email you received from Apple.
          </h1>
          <div className="ClaimsAuthorizationEmail-step">
            <h2 className="ClaimsAuthorizationEmail-step-heading">
              Step 1
            </h2>
            <p className="ClaimsAuthorizationEmail-step-instruction">
              Search for an email from Apple with the subject line “Your Apple Store Work Authorization”
            </p>
          </div>
          <div className="ClaimsAuthorizationEmail-step">
            <h2 className="ClaimsAuthorizationEmail-step-heading">
              Step 2
            </h2>
            <p className="ClaimsAuthorizationEmail-step-instruction">
              Copy your iPhone serial number from the email and paste it below:
            </p>
            <TextInput
              required
              name="deviceSerialNumber"
              placeholder="Your iPhone serial number"
              ref={(c) => this.inputSerialNumber = c}
              onChange={this.setNextButtonState.bind(this)}
            />
          </div>
          <div className="ClaimsAuthorizationEmail-step">
            <h2 className="ClaimsAuthorizationEmail-step-heading">
              Step 3
            </h2>
            <p className="ClaimsAuthorizationEmail-step-instruction">
              Forward your Apple Store Work Authorization to:
            </p>
            <p
              className="ClaimsAuthorizationEmail-step-claimsEmail"
              ref={(c) => this.claimsEmail = c}
              onClick={this.selectEmailText.bind(this)}>
              claims@sureapp.com
            </p>
          </div>
          <div className="ClaimsAuthorizationEmail-step">
            <h2 className="ClaimsAuthorizationEmail-step-heading">
              Step 4
            </h2>
            <p className="ClaimsAuthorizationEmail-step-instruction">
              Once you’ve forwarded the email, please check the following:
            </p>
            <CheckboxButton
              name="confirmation"
              value="confirmation"
              title="I confirm that I have forwarded to Sure the original Apple Store Work Authorization email."
              ref={(c) => this.confirmationCheckbox = c}
              onChange={this.setNextButtonState.bind(this)}
            />
          </div>
          <Button
            disabled={!this.state.isNextButtonEnabled}
            onClick={this.handleNext.bind(this)}>
            Next
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    navTo: (route) => dispatch(push(route)),
    saveClaimsDeviceSerialNumber: (serialNumber) => dispatch(saveClaimsDeviceSerialNumber(serialNumber)),
  };
};

export default connect(
  mapStateToProps, mapDispatchToProps
)(withRouter(ClaimsAuthorizationEmail));
